"use strict";

exports.__esModule = true;
exports.calculateXY = void 0;
var _constants = require("../constants");
var calculateXY = exports.calculateXY = function calculateXY(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$textAnchor = _ref.textAnchor,
    textAnchor = _ref$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _ref$textAnchor;
  return {
    x: textAnchor === _constants.TEXT_ANCHOR_START ? 0 : textAnchor === _constants.TEXT_ANCHOR_END ? width : width / 2,
    y: height / 2
  };
};